import * as Yup from 'yup'
import React from 'react'
import { Formik, FormikHelpers, FormikProps } from 'formik'
import Drawer from '../Drawer'
import Spinner from '../Spinner'
import { createSearchParams, useNavigate } from 'react-router-dom'
import { useParamsToObj } from '../../hooks/useParamsToObj'
import AppUserFiltersForm from './AppUserFiltersForm'

// TODO: Add next form inputs to filter

type AppUserDrawerProps = {
  onClose: () => void
  open: boolean
}

export type FilterData = {
  status: 'ACTIVE' | 'INACTIVE' | ''
  area: ''
  nbSharedExperiences_gte: ''
  nbSharedExperiences_lte: ''
}

const schema = Yup.object().shape({
  status: Yup.string().oneOf(['ACTIVE', 'INACTIVE']),
  area: Yup.string(),
  nbSharedExperiences_gte: Yup.string(),
  nbSharedExperiences_lte: Yup.string(),
})

const AppUserFilterDrawer: React.FC<AppUserDrawerProps> = ({ onClose, open }) => {
  const navigate = useNavigate()
  const urlParams = useParamsToObj(['search', 'status', 'area', 'nbSharedExperiences_gte', 'nbSharedExperiences_lte'])

  const initialValues: FilterData = {
    status: urlParams.status || '',
    area: urlParams.area || '',
    nbSharedExperiences_gte: urlParams.nbSharedExperiences_gte || '',
    nbSharedExperiences_lte: urlParams.nbSharedExperiences_lte || '',
  }

  const handleOnSubmit = async (
    { status, nbSharedExperiences_gte, nbSharedExperiences_lte }: FilterData,
    formikBag: FormikHelpers<FilterData>
  ) => {
    try {
      const searchParams = createSearchParams()

      if (urlParams.search) searchParams.append('search', urlParams.search)
      if (status) searchParams.append('status', status)
      if (nbSharedExperiences_gte) searchParams.append('nbSharedExperiences_gte', nbSharedExperiences_gte)
      if (nbSharedExperiences_lte) searchParams.append('nbSharedExperiences_lte', nbSharedExperiences_lte)

      navigate({
        search: `?${searchParams}`,
      })

      onClose()
    } catch (e: any) {
      console.log('🚀 ~ file: AppUserFilterDrawer.tsx ~ line 52 ~ handleOnSubmit ~ error', e)
    }
  }

  return (
    <Drawer open={open} onClose={onClose}>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={schema}
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={handleOnSubmit}
      >
        {({ isSubmitting, dirty, setFieldValue, values }: FormikProps<FilterData>) => (
          <Drawer.FormContainer
            open={open}
            onClose={onClose}
            title="Filters"
            Footer={
              <>
                <button
                  className="btn btn-white"
                  onClick={() => {
                    navigate({
                      search: ``,
                    })
                    onClose()
                  }}
                  disabled={isSubmitting}
                  type="button"
                >
                  Reset
                </button>

                <button className="btn btn-primary ml-4" type="submit" disabled={isSubmitting || !dirty}>
                  {isSubmitting ? (
                    <>
                      <Spinner className="h-5 w-5 text-gray-700" aria-hidden="true" />
                      Loading
                    </>
                  ) : (
                    'Apply'
                  )}
                </button>
              </>
            }
          >
            <AppUserFiltersForm isSubmitting={isSubmitting} setFieldValue={setFieldValue} values={values} />
          </Drawer.FormContainer>
        )}
      </Formik>
    </Drawer>
  )
}

export default AppUserFilterDrawer
